/* eslint-disable max-len */
import React, { Fragment } from 'react'

export class Icon {
  constructor (viewBox, svg) {
    this.viewBox = viewBox || '0 0 20 20'
    this.svg = <Fragment>{svg}</Fragment>
  }
}

const svgs = {
  'hamburger': new Icon('0 0 20 20',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Search-Grid-View-Desktop' transform='translate(-1192.000000, -291.000000)'>
        <rect id='Rectangle' x='1192' y='291' width='20' height='4' />
        <rect id='Rectangle' x='1192' y='299' width='20' height='4' />
        <rect id='Rectangle' x='1192' y='307' width='20' height='4' />
      </g>
    </g>
  ),
  'gridview': new Icon('0 0 20 20',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Desktop-HD-Copy-32' transform='translate(-1220.000000, -291.000000)'>
        <rect id='Rectangle' x='1220' y='291' width='9' height='8' />
        <rect id='Rectangle' x='1231' y='291' width='9' height='8' />
        <rect id='Rectangle' x='1220' y='303' width='9' height='8' />
        <rect id='Rectangle' x='1231' y='303' width='9' height='8' />
      </g>
    </g>
  ),
  'search': new Icon('0 0 14 14',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Desktop-HD-Copy-33' transform='translate(-216.000000, -94.000000)' fill='var(--text-hint)'>
        <g id='Bars-/-Search-Bar-/-x---Glyphs-/-On-Dark---Search-Glyph-Copy' transform='translate(216.000000, 94.000000)'>
          <path d='M13.7430947,12.5740557 L9.91009465,8.73955572 C10.5971654,7.80245935 10.9652265,6.66953223 10.9600947,5.50755572 C10.946985,2.47441147 8.49371664,0.0175744397 5.46059465,5.57178262e-05 C4.00907481,-0.00651157295 2.61521603,0.567712287 1.58953064,1.59480646 C0.56384524,2.62190064 -0.00846492859,4.01654626 9.46502197e-05,5.46805572 C0.0132043609,8.50147611 2.46669652,10.958537 5.50009465,10.9760557 C6.66680484,10.9811124 7.80387114,10.6087552 8.74159465,9.91455572 L8.74559465,9.91155572 L12.5750947,13.7430557 C12.7821435,13.9602692 13.0906604,14.0481921 13.3811096,13.9727584 C13.6715587,13.8973248 13.898302,13.6703873 13.9734871,13.3798737 C14.0486722,13.0893602 13.9604853,12.7809186 13.7430947,12.5740557 L13.7430947,12.5740557 Z M5.49609465,9.87805572 C3.06950871,9.86409673 1.1067469,7.89865842 1.09609465,5.47205572 C1.08954524,4.31099854 1.54743104,3.19550612 2.36782487,2.37389147 C3.1882187,1.55227681 4.30302902,1.09273279 5.46409465,1.09755572 C7.89068059,1.1115147 9.8534424,3.07695301 9.86409465,5.50355572 C9.87064406,6.6646129 9.41275826,7.78010532 8.59236443,8.60171997 C7.7719706,9.42333462 6.65716028,9.88287864 5.49609465,9.87805572 Z' id='Search' />
        </g>
      </g>
    </g>
  ),
  'cancel': new Icon('0 0 15 15',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' strokeLinecap='square'>
      <g id='Desktop-HD-Copy-33' transform='translate(-1202.000000, -206.000000)' stroke='#979797'>
        <path d='M1202.5,206.5 L1216.5,220.5' id='Line-2' />
        <path d='M1216.5,206.5 L1202.5,220.5' id='Line-3' />
      </g>
    </g>
  ),
  'cancelCircle': new Icon('0 0 20 20',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Desktop-HD-Copy-39' transform='translate(-367.000000, -142.000000)'>
        <rect fill='none' x='0' y='0' width='1440' height='2779' />
        <g id='close_filter' transform='translate(368.000000, 143.000000)' stroke='var(--primary)'>
          <g id='Group-4'>
            <circle id='Oval' cx='9' cy='9' r='9' />
            <path d='M5.09479512,4.72631413 L13.2843854,13.9189424' id='Line-6' strokeLinecap='round' transform='translate(9.094795, 9.596314) rotate(-3.302581) translate(-9.094795, -9.596314) ' />
            <path d='M5.09479512,4.72631413 L13.2843854,13.9189424' id='Line-6' strokeLinecap='round' transform='translate(9.094795, 9.596314) scale(-1, 1) rotate(-3.302581) translate(-9.094795, -9.596314) ' />
          </g>
        </g>
      </g>
    </g>
  ),
  'filter': new Icon('0 0 15 14',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='iPhone-SE-Copy-35' transform='translate(-207.000000, -88.000000)' fill='#2F2F2F' fillRule='nonzero'>
        <g id='Group-5' transform='translate(192.000000, 80.000000)'>
          <g id='Group' transform='translate(15.000000, 6.000000)'>
            <g id='filter' transform='translate(0.000000, 2.000000)'>
              <path d='M14.9565967,0.263986497 C14.8815544,0.102808041 14.721347,0 14.5453795,0 L0.454644359,0 C0.278676863,0 0.118530076,0.102808041 0.0434271725,0.263986497 C-0.0316151149,0.425164953 -0.0080962074,0.615682062 0.103861066,0.753168636 L5.5205443,7.4055547 L5.5205443,13.5396655 C5.5205443,13.6989412 5.60183001,13.8468621 5.7354271,13.9308271 C5.80865092,13.9767991 5.8917551,14 5.97516236,14 C6.04408245,14 6.11324501,13.9841031 6.17701277,13.9521252 L9.2204079,12.4247353 C9.37503865,12.3471536 9.47287246,12.1876323 9.47311492,12.0128894 L9.47905527,7.40573884 L14.8960416,0.753107258 C15.0080595,0.615682062 15.031639,0.425103575 14.9565967,0.263986497 Z M8.67395699,6.94736842 C8.6069766,7.02961485 8.57024346,7.13291392 8.57012223,7.23958877 L8.56430312,11.7264999 L6.42984103,12.797729 L6.42984103,7.24020255 C6.42984103,7.13334356 6.39316851,7.02979899 6.32600627,6.94736842 L1.4186771,0.920607642 L13.5812862,0.920607642 L8.67395699,6.94736842 Z' id='Shape' />
            </g>
          </g>
        </g>
      </g>
    </g>
  ),
  'downShortArrow': new Icon('0 0 13 11',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='iPhone-SE-Copy-34' transform='translate(-283.000000, -73.000000)' fill='#D8D8D8'>
        <g id='Group-2' transform='translate(16.000000, 68.000000)'>
          <polygon id='Triangle-Copy-3' transform='translate(273.500000, 10.500000) scale(1, -1) translate(-273.500000, -10.500000) ' points='273.5 5 280 16 267 16' />
        </g>
      </g>
    </g>
  ),
  'prevArrowSwiper': new Icon('0 0 27 44',
    <path d='M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z' />
  ),
  'nextArrowSwiper': new Icon('0 0 27 44',
    <path d='M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z' />
  ),
  'longRigthArrow': new Icon('0 0 24 11',
    <>
      <line x1='0.75' y1='5.25' x2='23.25' y2='5.25' stroke='var(--primary)' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <line x1='22.9458' y1='4.88287' x2='19.8829' y2='1.05417' stroke='var(--primary)' strokeWidth='1.5' strokeLinecap='round' />
      <line x1='0.75' y1='-0.75' x2='5.65312' y2='-0.75' transform='matrix(-0.624695 0.780869 0.780869 0.624695 24 5.5)' stroke='var(--primary)' strokeWidth='1.5' strokeLinecap='round' />
    </>
  ),
  'rigthArrowSwiper': new Icon('0 0 23 41',
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-1137.000000, -299.000000)'>
        <g id='next-new-(same-width)' transform='translate(1137.000000, 299.000000)' fill='var(--primary)' fillRule='nonzero'>
          <path d='M0.668253328,3.88469172 C0.0890269508,3.30695145 -0.134995122,2.46704721 0.0805740591,1.6813628 C0.29614324,0.895678402 0.918553587,0.283577994 1.71334914,0.0756338837 C2.50814469,-0.132310226 3.3545771,0.0954936202 3.93380345,0.673233917 L22.3312689,18.8942711 C23.2229104,19.782632 23.2229104,21.217368 22.3312689,22.1057289 L3.93380345,40.3267661 C3.3545771,40.9045064 2.50814469,41.1323102 1.71334913,40.9243661 C0.918553569,40.716422 0.296143216,40.1043216 0.0805740368,39.3186372 C-0.134995143,38.5329528 0.0890269389,37.6930485 0.668253328,37.1153083 L17.4329437,20.5113881 L0.668253328,3.88469172 Z' id='Path' />
        </g>
      </g>
    </g>
  ),
  'leftArrowSwiper': new Icon('0 0 23 41',
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-1137.000000, -453.000000)'>
        <g transform='translate(1148.500000, 473.500000) scale(-1, 1) translate(-1148.500000, -473.500000) translate(1137.000000, 453.000000)' fill='var(--primary)' fillRule='nonzero'>
          <path d='M0.668253328,3.88469172 C0.0890269508,3.30695145 -0.134995122,2.46704721 0.0805740591,1.6813628 C0.29614324,0.895678402 0.918553587,0.283577994 1.71334914,0.0756338837 C2.50814469,-0.132310226 3.3545771,0.0954936202 3.93380345,0.673233917 L22.3312689,18.8942711 C23.2229104,19.782632 23.2229104,21.217368 22.3312689,22.1057289 L3.93380345,40.3267661 C3.3545771,40.9045064 2.50814469,41.1323102 1.71334913,40.9243661 C0.918553569,40.716422 0.296143216,40.1043216 0.0805740368,39.3186372 C-0.134995143,38.5329528 0.0890269389,37.6930485 0.668253328,37.1153083 L17.4329437,20.5113881 L0.668253328,3.88469172 Z' id='Path' />
        </g>
      </g>
    </g>
  ),
  'rightChevron': new Icon('0 0 8 14',
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Artboard' transform='translate(-360.000000, -321.000000)'>
        <g id='icon-/-next' transform='translate(360.000000, 321.500000)' fill='var(--border-input)' fillRule='nonzero'>
          <path d='M0.23243594,1.3264801 C0.0309658959,1.12920293 -0.046954825,0.842406363 0.0280257597,0.574123884 C0.103006344,0.305841406 0.3194969,0.0968315101 0.595947527,0.0258262042 C0.872398154,-0.0451791017 1.16680943,0.0326075776 1.36827946,0.229884752 L7.76739789,6.45170232 C8.07753404,6.75504506 8.07753404,7.24495493 7.76739789,7.54829767 L1.36827946,13.7701152 C1.16680943,13.9673924 0.872398153,14.0451791 0.595947523,13.9741738 C0.319496893,13.9031685 0.103006336,13.6941586 0.0280257519,13.4258761 C-0.0469548322,13.1575936 0.0309658918,12.8707971 0.23243594,12.6735199 L6.06363261,7.00388863 L0.23243594,1.3264801 Z' id='Path' />
        </g>
      </g>
    </g>
  ),
  'calendar': new Icon('0 0 20 20',
    <>
      <rect x='0.5' y='2.5' width='19' height='17' rx='1.5' stroke='var(--text-hint)' strokeLinejoin='round' />
      <rect x='4.5' y='7.5' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='4.5' y='11' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='4.5' y='14.5' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='9.5' y='7.5' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='9.5' y='11' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='9.5' y='14.5' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='14.5' y='7.5' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='14.5' y='11' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <rect x='14.5' y='14.5' width='1' height='1' fill='#D8D8D8' stroke='var(--text-hint)' />
      <path d='M5 0.5V4.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M15 0.5V4.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M10 0.5V4.5' stroke='var(--text-hint)' strokeLinecap='round' />
    </>
  ),
  'articles': new Icon('0 0 20 20',
    <>
      <rect width='20' height='20' fill='white' />
      <path d='M0.5 19.4V0.6C0.5 0.544772 0.544771 0.5 0.6 0.5H19.4C19.4552 0.5 19.5 0.544771 19.5 0.6V19.4C19.5 19.4552 19.4552 19.5 19.4 19.5H0.6C0.544772 19.5 0.5 19.4552 0.5 19.4Z' stroke='var(--text-hint)' />
      <path d='M17.5 6.4V2.6C17.5 2.54477 17.4552 2.5 17.4 2.5H10.6C10.5448 2.5 10.5 2.54477 10.5 2.6V6.4C10.5 6.45523 10.5448 6.5 10.6 6.5H17.4C17.4552 6.5 17.5 6.45523 17.5 6.4Z' stroke='var(--text-hint)' />
      <path d='M17.5 10.5H2.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M8.5 4.5H2.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M17.5 15.5H2.5' stroke='var(--text-hint)' strokeLinecap='round' />
    </>
  ),
  'products': new Icon('0 0 20 20',
    <>
      <path d='M4 8.5V15.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M10 12.5V19.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M16 8.5V15.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M4 8.5L10 12.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M10 4.5L16 8.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M4 15.5L10 19.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M0.5 15V18' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M0.5 18L2.99615 19.6641' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M19.5 15V18' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M19.4962 18L17 19.6641' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M12.4962 2.1641L10 0.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M9.99615 0.5L7.5 2.1641' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M16 8.5L10 12.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M10 4.5L4 8.5' stroke='var(--text-hint)' strokeLinecap='round' />
      <path d='M16 15.5L10 19.5' stroke='var(--text-hint)' strokeLinecap='round' />
    </>
  ),
  'projects': new Icon('0 0 20 20',
    <g>
      <rect width='20' height='20' fill='var(--background)' />
      <path id='Vector 6' d='M0.5 19.4V0.6C0.5 0.544772 0.544771 0.5 0.6 0.5H19.4C19.4552 0.5 19.5 0.544771 19.5 0.6V19.4C19.5 19.4552 19.4552 19.5 19.4 19.5H0.6C0.544772 19.5 0.5 19.4552 0.5 19.4Z' stroke='var(--text-hint)' />
      <path id='Line 9' d='M6 17.5H11' stroke='var(--text-hint)' strokeLinecap='round' />
      <path id='Line 9_2' d='M8 15.5H11' stroke='var(--text-hint)' strokeLinecap='round' />
      <path id='Vector 5' d='M12.4 2.5H2.6C2.54477 2.5 2.5 2.54477 2.5 2.6V7.4C2.5 7.45523 2.54477 7.5 2.6 7.5H6.4C6.45523 7.5 6.5 7.54477 6.5 7.6V10.4C6.5 10.4552 6.45523 10.5 6.4 10.5H3.6C3.54477 10.5 3.5 10.5448 3.5 10.6V13.4C3.5 13.4552 3.54477 13.5 3.6 13.5H17.4C17.4552 13.5 17.5 13.4552 17.5 13.4V2.6C17.5 2.54477 17.4552 2.5 17.4 2.5H14.6C14.5448 2.5 14.5 2.54477 14.5 2.6V4.9C14.5 4.95523 14.4552 5 14.4 5H12.6C12.5448 5 12.5 4.95523 12.5 4.9V2.6C12.5 2.54477 12.4552 2.5 12.4 2.5Z' stroke='var(--text-hint)' />
      <path id='Vector 7' d='M13.5 17.4V15.6C13.5 15.5448 13.5448 15.5 13.6 15.5H17.4C17.4552 15.5 17.5 15.5448 17.5 15.6V17.4C17.5 17.4552 17.4552 17.5 17.4 17.5H13.6C13.5448 17.5 13.5 17.4552 13.5 17.4Z' stroke='var(--text-hint)' />
    </g>
  ),
  'images': new Icon('0 0 20 20',
    <>
      <rect x='0.5' y='0.5' width='19' height='19' stroke='var(--text-hint)' />
      <path d='M11.0233 8.07147L15.1502 15.5H4.80902L7.08541 10.9472L8.1 12.3L8.58541 12.9472L8.94721 12.2236L11.0233 8.07147Z' stroke='var(--text-hint)' strokeLinecap='round' />
      <circle cx='7' cy='6' r='1.5' stroke='var(--text-hint)' />
    </>
  ),
  'folders': new Icon('0 0 20 20',
    <path fillRule='evenodd' clipRule='evenodd' d='M3.1252 3C2.76081 3 2.46549 3.31034 2.46549 3.70654V5.09996H1.15388C0.792967 5.09996 0.5 5.41823 0.5 5.80003V16.3C0.5 16.6865 0.798414 17 1.15388 17H18.8461C19.207 17 19.5 16.6818 19.5 16.3V5.80003C19.5 5.41346 19.2015 5.09996 18.8461 5.09996L11.6379 5.0935V3.70654C11.6379 3.31657 11.343 3 10.9782 3H3.1252Z' stroke='var(--text-hint)' />
  ),
  'competitions': new Icon('0 0 20 20',
    <>
      <path d='M10 0.5C6.54545 0.5 4 3.54545 4 7C4 10.4545 7 14 7 14V18.3636C7 18.9912 7.50877 19.5 8.13636 19.5H11.8636C12.4912 19.5 13 18.9912 13 18.3636V14C13 14 16 10.4545 16 7C16 3.54545 13.4545 0.5 10 0.5Z' stroke='var(--text-hint)' strokeWidth='1.13636' />
      <path d='M7 14.5L13 14.5' stroke='var(--text-hint)' strokeWidth='1.13636' />
      <path d='M7 17L13 17' stroke='var(--text-hint)' strokeWidth='1.13636' />
    </>
  ),
  'galleryPrevChevron': new Icon('0 0 44 93',
    <g>
      <path d='M31.68 86.5L7.6 46.5l24.08-40 4.72 2.84L14.03 46.5 36.4 83.66z' />
    </g>
  ),
  'galleryNextChevron': new Icon('0 0 44 93',
    <g>
      <path d='M7.6 83.66L29.97 46.5 7.6 9.34l4.72-2.84 24.08 40-24.08 40z' />
    </g>
  ),
  'share': new Icon('0 0 20 15',
    <g>
      <path d='M12 0l8.002 7.227L12 14.454v-3.98C3.272 10.629 0 14.6 0 14.6S3.059 3.451 12 3.105V0z' fill='var(--text-body)' fillRule='evenodd' />
    </g>
  ),
  'externalLink': new Icon('0 0 20 20',
    <g>
      <path d='M19.4 20H.6c-.3 0-.6-.3-.6-.6V.6C0 .3.3 0 .6 0H10c.3 0 .5.2.5.5s-.2.5-.5.5H1v18h18v-9c0-.3.2-.5.5-.5s.5.2.5.5v9.4c0 .3-.3.6-.6.6z' />
      <path d='M10.5 10c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7L18.3 1h-4.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6.2c.1 0 .1.1.2.1 0 0 .1.1.1.2v6.2c0 .3-.2.5-.5.5s-.5-.2-.5-.5V1.7l-8.1 8.1c-.1.2-.3.2-.4.2z' />
    </g>
  ),
  'architects': new Icon('0 0 20 20',
    <>
      <circle cx='10' cy='4' r='3' stroke='var(--text-hint)' />
      <circle cx='17' cy='6' r='2' stroke='var(--text-hint)' />
      <circle cx='3' cy='6' r='2' stroke='var(--text-hint)' />
      <path d='M0.5 17.5V12C0.5 11.4477 0.947715 11 1.5 11H4C4.55228 11 5 11.4477 5 12V17.5' stroke='var(--text-hint)' />
      <path d='M15 17.5V12C15 11.4477 15.4477 11 16 11H18.5C19.0523 11 19.5 11.4477 19.5 12V17.5' stroke='var(--text-hint)' />
      <path d='M5 17V12.5C5 11.3954 5.89543 10.5 7 10.5H13C14.1046 10.5 15 11.3954 15 12.5V17' stroke='var(--text-hint)' />
    </>
  ),
  'crosshair': new Icon('0 0 20 20',
    <>
      <path d='M10 1V8' stroke='var(--text-hint)' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M10 12V19' stroke='var(--text-hint)' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M19 10L12 10' stroke='var(--text-hint)' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M8 10L1 10' stroke='var(--text-hint)' strokeLinecap='round' strokeLinejoin='round' />
      <circle cx='10' cy='10' r='7.5' stroke='var(--text-hint)' />
      <circle cx='10' cy='10' r='3.5' stroke='var(--text-hint)' />
    </>
  ),
  'expertises': new Icon('0 0 20 20',
    <>
      <rect width='20' height='20' fill='white' />
      <path d='M10 19.5H19.4C19.4552 19.5 19.5 19.4552 19.5 19.4V10M10 19.5V15.6281C10 15.563 9.93886 15.5153 9.87575 15.5311L8.12425 15.9689C8.06114 15.9847 8 15.937 8 15.8719V13.6281C8 13.563 8.06114 13.5153 8.12425 13.5311L9.87575 13.9689C9.93886 13.9847 10 13.937 10 13.8719V10M10 19.5H0.6C0.544772 19.5 0.5 19.4552 0.5 19.4V10M10 0.5H6.12808C6.06302 0.5 6.01528 0.561139 6.03106 0.624254L6.46894 2.37575C6.48472 2.43886 6.43698 2.5 6.37192 2.5H4.12808C4.06302 2.5 4.01528 2.43886 4.03106 2.37575L4.46894 0.624254C4.48472 0.561139 4.43698 0.5 4.37192 0.5H0.6C0.544771 0.5 0.5 0.544772 0.5 0.6V10M10 0.5V4.37192C10 4.43698 10.0611 4.48472 10.1243 4.46894L11.8757 4.03106C11.9389 4.01528 12 4.06302 12 4.12808V6.37192C12 6.43698 11.9389 6.48472 11.8757 6.46894L10.1243 6.03106C10.0611 6.01528 10 6.06302 10 6.12808V10M10 0.5H19.4C19.4552 0.5 19.5 0.544772 19.5 0.6V10M0.5 10H4.37192C4.43698 10 4.48472 9.93886 4.46894 9.87575L4.03106 8.12425C4.01528 8.06114 4.06302 8 4.12808 8H6.37192C6.43698 8 6.48472 8.06114 6.46894 8.12425L6.03106 9.87575C6.01528 9.93886 6.06302 10 6.12808 10H10M10 10H13.8719C13.937 10 13.9847 10.0611 13.9689 10.1243L13.5311 11.8757C13.5153 11.9389 13.563 12 13.6281 12H15.8719C15.937 12 15.9847 11.9389 15.9689 11.8757L15.5311 10.1243C15.5153 10.0611 15.563 10 15.6281 10H19.5' stroke='currentColor' />
    </>
  ),
  'archive': new Icon('0 0 30 30',
    <>
      <path d='M25.6248 25.625V10.625H4.37476V25.625H25.6248Z' stroke='currentColor' fill='none' strokeWidth='1.57895' strokeLinecap='square' />
      <path d='M7.5 10.625V3.125H13.125L15.625 5.625H22.5V10.625' stroke='currentColor' fill='none' strokeWidth='1.57895' strokeLinecap='square' />
      <path d='M9.37524 15.625H14.3752' stroke='currentColor' strokeWidth='1.57895' fill='none' strokeLinecap='square' strokeLinejoin='round' />
    </>
  ),
  'sort': new Icon('0 0 20 20',
    <>
      <path fill='currentColor' stroke='none' d='M17,4H4v1h13v-1Z' />
      <path fill='currentColor' stroke='none' d='M13,9H4v1h9v-1Z' />
      <path fill='currentColor' stroke='none' d='M10,14h-6v1h6v-1Z' />
    </>
  )
}

export default svgs
